import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import NaCountryCodeKeys from 'src/constants/locale/key/NaCountryCode'
import { constants } from 'cng-web-lib'

const {
  locale: {
    key: { CommonValidationMessageKeys },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    code: Yup.string()
      .required(requiredMessage)
      .max(10, translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.Validations.MAX_LENGTH_10))
      .nullable(),
    descriptionEn: Yup.string()
      .required(requiredMessage)
      .max(100, translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.Validations.MAX_LENGTH_100))
      .nullable(),
    indicator: Yup.string()
      .required(requiredMessage)
      .max(10, translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.Validations.MAX_LENGTH_10))
      .nullable(),
    intlcode: Yup.string()
      .max(5, translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.Validations.MAX_LENGTH_5))
      .nullable(),
    active: Yup.boolean().nullable(),
  })
}

export default makeValidationSchema
